/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Toolkit_LicenseInputs */

const en_pc_alt_t_toolkit_license = /** @type {(inputs: Pc_Alt_T_Toolkit_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source (AGPL-3.0)`)
};

const zh_pc_alt_t_toolkit_license = /** @type {(inputs: Pc_Alt_T_Toolkit_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源（AGPL-3.0）`)
};

/**
* | output |
* | --- |
* | "Open source (AGPL-3.0)" |
*
* @param {Pc_Alt_T_Toolkit_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_toolkit_license = /** @type {((inputs?: Pc_Alt_T_Toolkit_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Toolkit_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_toolkit_license(inputs)
	return zh_pc_alt_t_toolkit_license(inputs)
});
export { pc_alt_t_toolkit_license as "pc.alt.t.toolkit.license" }